import { render, staticRenderFns } from "./radishScoreInner.vue?vue&type=template&id=cb420af6&scoped=true&"
import script from "./radishScoreInner.vue?vue&type=script&lang=js&"
export * from "./radishScoreInner.vue?vue&type=script&lang=js&"
import style0 from "./radishScoreInner.vue?vue&type=style&index=0&id=cb420af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb420af6",
  null
  
)

export default component.exports